<!--
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zouyuping
 * @Date: 2022-04-11 09:43:50
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-06-20 11:49:07
-->
<template>
  <div>
    <van-overlay :show="isShow" @click="changeShow">
      <div class="wrapper">
        <div class="block" @click.stop>
          <div class="top c-p-20 c-main-txt c-f-ar">
            {{ title }}
            <g-img
              class="close-img"
              :src="require('@/assets/images/close.png')"
              :size="40"
              @click="changeShow"
            ></g-img>
          </div>
          <div class="modal_con">
            <slot></slot>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  name: "GDialog2",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isShow: this.show,
    };
  },
  watch: {
    show(val) {
      console.log(
        "%c val ",
        "background-image:color:transparent;color:blue;font-size:2em"
      );
      console.log(val);
      this.isShow = val;
    },
  },
  created() {},
  mounted() {},
  methods: {
    changeShow() {
      this.isShow = false;
      this.$emit("update:show", false);
    },
  },
};
</script>
<style scoped lang="scss">
.wrapper {
  display: flex;
  /* align-items: center; */
  justify-content: center;
  margin-top: 200px;
  height: 100%;
}
.top {
  background: #eee;
  position: relative;
  .close-img {
    position: absolute;
    right: 10px;
  }
}

.block {
  width: 600px;
  height: 600px;
  overflow: hidden;
  background-color: #fff;
  .modal_con {
    height: calc(100% - 50px);
    overflow-y: auto;
  }
}
</style>
